import { DateInput, Select } from '@octano/global-ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDetailsFormLoaderData } from '../loaders/StudentWarningsSummaryDetailsFormLoader';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';
import { buildDetailsURL } from '../utils';

const StudentWarningsSummaryDetailsFilters = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);
  const data = useWarningsSummaryDetailsFormLoaderData();
  const { query, updateQuery } = useWarningsSummaryDetailsLoader();

  const handleChangeFilter = useCallback(
    (field: keyof typeof query, value: string | Date | undefined) => {
      const nextQuery = { ...query, [field]: value ?? undefined, page: 1 };
      if (!nextQuery[field]) {
        delete nextQuery[field];
      }
      updateQuery(nextQuery);
      window.history.replaceState(
        null,
        '',
        buildDetailsURL(nextQuery.studyPlanEnrollmentId, nextQuery),
      );
    },
    [query, updateQuery],
  );

  if (!data) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        <Col xs={12} sm={6} md={3}>
          <Select
            name="year"
            value={data?.years?.find(
              (e) => e.value.toString() === query.year?.toString(),
            )}
            options={data?.years || []}
            label={t('filters.year.label')}
            placeholder={t('filters.year.placeholder')}
            onChange={(option) => handleChangeFilter('year', option?.value)}
            isClearable={false}
            disabled={data?.years?.length < 1}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Select
            name="periodId"
            value={data?.periods?.find(
              (e) => e.value.toString() === query.periodId?.toString(),
            )}
            options={data?.periods || []}
            label={t('filters.period.label')}
            placeholder={t('filters.period.placeholder')}
            onChange={(option) => handleChangeFilter('periodId', option?.value)}
            isClearable={false}
            disabled={data?.periods?.length < 1}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <DateInput
            name="startAt"
            value={query.startAt || ''}
            label={t('filters.startAt.label')}
            onChange={(value) =>
              handleChangeFilter('startAt', value ?? undefined)
            }
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <DateInput
            name="endAt"
            value={query.endAt || ''}
            label={t('filters.endAt.label')}
            onChange={(value) =>
              handleChangeFilter('endAt', value ?? undefined)
            }
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryDetailsFilters;
